<template>
  <component
    :is="tag"
    :class="[
      $style.squareLink,
      {
        [$style.squareLinkDisabled]: disabledStyle,
        [$style.squareLinkActive]: isActive,
      },
    ]"
  >
    <span :class="$style.squareLinkIcon">
      <slot name="icon" />
    </span>
    <slot name="text" />
  </component>
</template>

<script setup>
  defineProps({
    tag: {
      type: [String, Object],
      required: true,
    },
    disabledStyle: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  });
</script>

<style module lang="scss">
$p: ".squareLink";
#{$p} {
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0;
  transition: all 0.32s ease-in-out;
  text-decoration: none !important;
  border: none;
  inline-size: fit-content;
  gap: var(--awSquareLinkGap, 8px);

  @include desktop-small(min) {
    font-size: 14px;
    line-height: 20px;
  }

  &Icon {
    display: var(--awSquareLinkIconDisplay, flex);
    overflow: hidden;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    height: var(--awSquareLinkIconHeight, unset);
    min-height: var(--awSquareLinkIconMinHeight, 40px);
    transition: all 0.32s ease-in-out;
    border: var(--awSquareLinkIconBorder, 1px solid $color-background-1);
    border-radius: 12px;
    background: $color-white;
    box-shadow: 0 2px 8px 0 $color-olive-750--8;
    scale: var(--awSquareLinkIconScale, 1);

    &:empty {
      display: none;
    }
  }

  &Disabled {
    cursor: not-allowed;
    opacity: 0.6;

    #{$p}Icon {
      box-shadow: none;
    }
  }

  &:hover,
  &:focus {
    &:not(#{$p}Disabled) {
      #{$p}Icon {
        @include desktop-small(min) {
          border-color: $color-border;
          background: $color-background-2;
          box-shadow: none;
        }
      }
    }
  }

  &:focus-visible {
    border-radius: 8px;
    outline: 2px solid currentColor;
  }

  &:active:not(#{$p}Disabled) {
    #{$p}Icon {
      border-color: $color-white;
      background: $color-background-1;
      box-shadow: none;
    }
  }

  &[data-aw-is-active="true"], &#{$p}Active {
    color: $color-strawberry-500;

    #{$p}Icon {
      border-color: transparent;
      background: $color-strawberry-450--12;
      box-shadow: none;
    }

    &:focus-visible {
      #{$p}Icon {
        border-color: $color-strawberry-500;
      }
    }

    &:hover,
    &:focus {
      #{$p}Icon {
        border-color: transparent;
        background: $color-strawberry-450--12;
        box-shadow: none;
      }
    }
  }
}
</style>
